import React, { useEffect, useCallback, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { deepOrange, red } from '@material-ui/core/colors';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Card,
  Grid, CardContent, makeStyles,
  Divider
} from '@material-ui/core';
import './ManagePlaylistModal.scss';
// import CheckboxList from './CheckBoxListData.js';
import { uploadContentService } from '../../../services';
import CustomizedSelects from '../Dropdowns';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

});

const useStyles = makeStyles((theme) => ({
  containers: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardcontent: {
    padding: 40,
  },

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 350,
    marginTop: 15,
    backgroundColor: '#FFFFFF',
    padding: 5,

  },
  avatar: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',

  },
  buttonMarkAll: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    width: 150,
    borderRadius: 0,
  },

  avatar1: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    maxWidth: '40px', maxHeight: '50px', minWidth: '30px', minHeight: '30px',
  },
  avatar2: {
    backgroundColor: deepOrange[800],
  },
  textColorChanger: {
    color: deepOrange[400],
  },
  buttonColor: {
    maxWidth: 150, maxHeight: 35, minWidth: 150, minHeight: 35,
    backgroundColor: deepOrange[500],
  },
  errors: {
    color: '#FF4949',
    fontSize: '15px'
  },
  '@global': {
    // You should target [class*='MuiButton-root'] instead if you nest themes.
    '.MuiInputBase-input': {
      color: 'white'
    },
    '.MuiSelect-select:not([multiple]) option, .MuiSelect-select:not([multiple]) optgroup': {
      backgroundColor: '#434343'
    }
  }
})
);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),

  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",

  },
}))(MuiDialogActions);


export default function ManagePlaylistModal({ modalShow, modalState,
  modalType, id, editInfo = undefined }) {
  const classes = useStyles();
  const fref = useRef();
  const [open, setOpen] = useState(modalShow);
  const { user } = useSelector(state => state.userAuthentication);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);


  const [playlistInputs, setPlaylistInputs] = useState({
    playlistName: '',
    mediaType: 'imgvideo'
  });

  const {
    playlistName,
    mediaType
  } = playlistInputs;

  if (modalType === 'edit') {
    if (!isLoaded) {
      if (editInfo !== undefined)
        setPlaylistInputs({
          playlistName: editInfo.name,
          mediaType: editInfo.mediaType
        })
      else
        setPlaylistInputs({
          playlistName: editInfo.name,
          mediaType: mediaType
        })

      setIsLoaded(true);
    }

  }

  const handleClose = () => {
    modalState(false);
  };

  const savePlaylist = () => {
    if (playlistName === '') {
      setErrorMessage('Playlist name is required')
      return;
    }
    if (modalType === 'add')
      uploadContentService.addDynamicPlaylist(user, playlistInputs);
    else
      uploadContentService.updateDynamicPlaylist(user, playlistInputs, id);
  }

  const handleChangePlaylistName = (e) => {
    setPlaylistInputs({
      playlistName: e.target.value,
      mediaType: mediaType
    })
  }

  const handleChangeMediaType = (e) => {
    setPlaylistInputs({
      playlistName: playlistName,
      mediaType: e.target.value
    })
  }

  return (
    <div >
      <Dialog TransitionComponent={Transition} disableBackdropClick={true}
        maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle className="dialog-header" id="customized-dialog-title" onClose={handleClose}>
          {modalType === 'add' ? 'Create Dynamic Playlist' : 'Edit Dynamic Playlist'}
        </DialogTitle>
        <DialogContent dividers className="dialog-content"  >
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <Grid lg={12} md={12} xs={12} >
              <Card className="card-main" justify="center" cot   >
                <CardContent style={{ overflow: 'auto' }}>
                  <Grid container item justify="center" lg={12} xs={12} md={12}>
                    <form noValidate autoComplete="off" >
                      <label className={classes.playlistLabel} > Name:
                        <TextField
                          className="credentials-input-field"
                          type="text"
                          id="playlistName"
                          name="playlistName"
                          placeholder=""
                          fullWidth
                          margin="normal"
                          autoFocus
                          value={playlistName}
                          onChange={handleChangePlaylistName}
                        />
                      </label>
                    </form>
                  </Grid>
                  {
                    errorMessage === '' ? '' :
                      <span className={classes.errors}>{errorMessage}</span>
                  }
                  <Grid container item style={{ marginTop: '10px' }}>
                    <RadioGroup aria-label="mediaType" name="mediaType1" value={mediaType} onChange={handleChangeMediaType}>
                      <FormControlLabel value="imgvideo" control={<Radio />} label="Image/Video Dynamic Playlist" />
                      <FormControlLabel value="audio" control={<Radio />} label="Audio Dynamic Playlist" />
                    </RadioGroup>
                  </Grid>
                  <p style={{ fontSize: '10px', color: '#adadad' }}> Requires firmware 4.7.146 or above </p>
                  
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classname="dialog-action">
          <Button onClick={handleClose} variant="contained" color="default">CANCEL</Button>
          <Button variant="contained" onClick={savePlaylist} className={classes.buttonColor}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}